module.exports = __webpack_public_path__ + "static/img/android.071386c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/android.png
// module id = KUj8
// module chunks = 1